export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  OK: 200,
};
